<div class="container-fluid" region="uploaded files grid">
  <div class="control-section">
  </div>
  <div class="col-sm-12 center-block">
    <h1 tabindex="0" aria-label="Welcome message" role="heading" aria-level="1">SPL Upload History</h1>
    <div class="row">
        <div class="col-sm-10">
            <p role="paragraph" aria-label="Greeting message" tabindex="0">
              All of the files below have been successfully uploaded to SingleSource. If you do not see a file name listed that you attempted to upload, the upload may have failed.
              Please try again. To determine if file data has been added to the SingleSource database, please consult the "Import Status" indicator.
            </p>
        </div>
        <!--align left-->
        <div class="col-sm-2">
          <div class="date-range-filter">
              <ejs-dropdownlist #ddDateRangeLimit
                  [width] ="150"
                  tabindex="0"
                  role="listbox"
                  aria-label="date range selection"
                  [dataSource]="dateRangeDataSource"
                  (change)="dateRangeSelectionChanged(ddDateRangeLimit.value)"
                  [value]="selectedDateRangeFilter"
              >
              </ejs-dropdownlist>
          </div>
      </div>
    </div>


  </div>
  <div class="col-sm-12" aria-label="draft order tab grid area">
    <label class="mb-1" *ngIf="selectedFileCount" tabindex="0" aria-label="Returned results counter">
      Selected: <span  class="badge badge-pill bg-warning"> {{ selectedFileCount }} </span> files
    </label>
    <ejs-tooltip #tooltipObj id="tooltipObj" (beforeRender)="tooltipValue($event)" [enableHtmlParse]="false"
      target=".e-ellipsistooltip" aria-hidden="true">
      <ejs-grid #historyGrid id="historyGrid" class="grid-striped" [dataSource]="data"
        [toolbar]='ordersGridToolbarOptions'
        allowSorting="true"
        (actionComplete)="complete($event)"
        allowFiltering="true"
        allowExcelExport="false"
        allowScrolling="true"
        [pageSettings]="appDefaults"
        [selectionSettings]="selectionOptions"
        [allowReordering]="true"
        height='600'
        [showColumnChooser]="true"
        [allowPaging]="true"
        tabindex="0"
        (rowSelected)="rowSelecting($event)"
        (dataBound)="dataBound($event)"
        (checkBoxChange)="checkBoxChange($event)"
        (created)="gridPreferencesService.onGridPreferencesRestore('fileUploadHistory', 'historyGrid', historyGrid)"
        (actionComplete)="gridPreferencesService.onGridPreferencesSave('fileUploadHistory', 'historyGrid', historyGrid, $event)"
        (beforeOpenColumnChooser)="gridPreferencesService.checkboxClick(historyGrid, disabledColumns)">
        <e-columns>
          <e-column type="checkbox" width="40"></e-column>
          <e-column field="orderNumber" headerText="Order ID" [showInColumnChooser]='false' width="250" tabindex="0">
            <ng-template #template let-data>
              <div class="d-flex">
                <div class="col-sm-8">{{data.orderNumber}}</div>
              </div>
            </ng-template>
          </e-column>
          <e-column field="fileName" headerText="File Name" width="250" title="File Name" [showInColumnChooser]='false' clipMode='EllipsisWithTooltip'>
            <ng-template #template let-data tabindex="0">
                <a class='pointer underline' *ngIf="data.filePath && !data?.isPurgedFile" (click)='downloadFile(data.filePath, data.fileName)'>
                  <i class="fas fa-download" title="Download the file"></i>
                  &nbsp;{{data.fileName}}
                </a>
                <span class="mx-2" *ngIf="data?.isPurgedFile">
                  {{data.fileName}}
                </span>
            </ng-template>
          </e-column>
          <e-column field="fileStatusText" headerText="Import Status" width="250" clipMode="EllipsisWithTooltip">
            <ng-template #template let-data>
              <div class="status">
                <i *ngIf="data?.fileStatus === splUploadFileStatus.Passed" class="fa-solid fa-check icon-success"></i>
                <i *ngIf="data?.fileStatus === splUploadFileStatus.Failed" class="fa-solid fa-xmark icon-danger"></i>
                <span *ngIf="data?.fileStatus === splUploadFileStatus.Received"><span class="small-loading-span"></span></span>
                <span *ngIf="data?.fileStatus === splUploadFileStatus.InProcess"><span class="small-loading-span"></span></span>
                <span class="mx-2">{{ data.fileStatusText }}</span>
              </div>
            </ng-template>
          </e-column>
          <e-column tabindex="0" field="logCount" headerText="Import Log" width="250" [allowFiltering]="false"
          [allowSorting]="false" clipMode='EllipsisWithTooltip' tabindex="0">
            <ng-template #template let-data tabindex="0">
            <span *ngIf="data?.logCount > 0">
                <a class='pointer underline' (click)='downloadLogFile(data.splUploadId, data.fileName)'>
                  <i class="fas fa-download" title="Download the file"></i>
                  &nbsp;Log_File
                </a>
              </span>
            </ng-template>
          </e-column>
          <e-column tabindex="0" field="llFormVersionNumber" headerText="LL form Version Number" width="250" clipMode='EllipsisWithTooltip'>
            <ng-template #template let-data>
              {{ formatVersionNumber(data.llFormVersionNumber) }}
          </ng-template>
          </e-column>
          <e-column tabindex="0" field="productName" headerText="Product Name" width="250" clipMode='EllipsisWithTooltip'>
            <ng-template #template let-data>
              <a *ngIf="!data?.revisionIsDeleted" class='pointer' (click)='viewFormOrGoToDashboard(data.formRevisionId, false)'
              tabindex="0" role="link" aria-label="View Form or Dashboard" (keydown.enter)="viewFormOrGoToDashboard(data.formRevisionId, false)">
              {{data.productName}}
              </a>
              <span *ngIf="data?.revisionIsDeleted" (click)="removedToasterWarning()">
                {{data.productName}}
              </span>
            </ng-template>
          </e-column>
          <e-column tabindex="0" field="uploadedBy" headerText="Imported By" width="250" clipMode='EllipsisWithTooltip'>
          </e-column>
          <e-column tabindex="0" field="uploadedDate" headerText="Imported Date/Time" width="250" type="date"
            [format]="dateFormat" clipMode='EllipsisWithTooltip'>
          </e-column>
          <e-column tabindex="0" field="uploadType" headerText="Ingestion Category" width="250" clipMode='EllipsisWithTooltip'>
            <ng-template #template let-data>
                <span *ngIf="data?.uploadType === 'ManualIngestion'">Manual Ingestion</span>
                <span *ngIf="data?.uploadType === 'OrderDelivery'">Order Delivery</span>
            </ng-template>
          </e-column>
          <e-column tabindex="0" field="pragmaticValidationStatus" headerText="Pragmatic Validation Status" width="250"
          clipMode='EllipsisWithTooltip'>
            <ng-template #template let-data>
                <app-pragmatic-grid-column [data]="data" (onDownload)="downloadFile($event.filePath, $event.fileName)"></app-pragmatic-grid-column>
            </ng-template>
          </e-column>
        </e-columns>
      </ejs-grid>
    </ejs-tooltip>
  </div>
</div>
